import * as React from 'react'
import { AppSeeker } from 'ui-seeker/core'
import { layoutSettings, navigations, roles, themeColors, themeOptions } from './app/config'
import { ExtractionDateContextProvider, Topbar, SettingContextProvider } from './app/layout'
import routes from './app/RootRoutes'

import 'rsuite/dist/rsuite.min.css'
import 'style/_index.scss'

export default function App() {

    const appConfig = {
        themeColors: themeColors,
        themeOptions: themeOptions,
        layoutSettings: layoutSettings,
        routes: routes,
        roles: roles,
        navigations: navigations,
        components: { Topbar: Topbar },
        Providers: ({ children }) => <SettingContextProvider>
            <ExtractionDateContextProvider>
                {children}
            </ExtractionDateContextProvider>
        </SettingContextProvider>
    }

    return <AppSeeker {...appConfig} />
}